import { useContext } from "react";
import { Loader2, Clock, Bell } from "lucide-react";
import { DataContext } from "@/App";
import { TimelineItem } from "@/components/TimelineItem";

export default function TimelineView() {
  const { events, subscriptions, loading } = useContext(DataContext);

  const subscribedEventIds = subscriptions.map((sub) => sub.event_id);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full p-8">
        <Loader2 className="animate-spin text-primary" size={48} />
      </div>
    );
  }

  return (
    <div className="p-4 pb-safe" data-testid="timeline-view">
      {/* Header with Logo */}
      <header className="mb-6 flex items-center gap-4">
        <img
          src="https://customer-assets.emergentagent.com/job_8e534113-c2c4-4f3f-8864-185da76b04eb/artifacts/d11zdlcb_XK%20Inclusive%20GameDay%20Logo.png"
          alt="XTERMIGATOR Kids Logo"
          className="w-20 h-20 object-contain"
        />
        <div>
          <h1
            className="text-xl font-bold text-foreground"
            style={{ fontFamily: "Lexend, sans-serif" }}
          >
            Activity Timeline
          </h1>
          <p className="text-xs text-muted-foreground">
            Game day events and sensory warnings
          </p>
          <p className="text-xs text-primary font-medium">XTERMIGATOR Kids</p>
        </div>
      </header>

      {/* Info Card */}
      <div className="info-card mb-6 flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Bell size={20} className="text-primary" />
        </div>
        <div>
          <h3
            className="font-medium text-sm"
            style={{ fontFamily: "Lexend, sans-serif" }}
          >
            Get Notified
          </h3>
          <p className="text-xs text-muted-foreground mt-1">
            Tap "Notify" on any event to receive an alert 5 minutes before. 
            This gives you time to prepare or find a quiet space.
          </p>
        </div>
      </div>

      {/* Timeline */}
      <section aria-label="Event timeline">
        {events.length > 0 ? (
          <div className="space-y-3">
            {events.map((event) => (
              <TimelineItem
                key={event.id}
                event={event}
                isSubscribed={subscribedEventIds.includes(event.id)}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <Clock size={48} className="mx-auto text-muted-foreground mb-4" />
            <p className="text-muted-foreground">
              No events scheduled at this time
            </p>
          </div>
        )}
      </section>

      {/* Footer Note */}
      <div className="mt-6 p-4 bg-secondary rounded-xl">
        <p className="text-xs text-muted-foreground text-center">
          Timeline shows events in order of occurrence. Events at the top
          happen first (furthest from game time).
        </p>
      </div>
    </div>
  );
}
